/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aaggSgVS8yYsAwQffVQB4p

import { createUseGlobalVariants } from "@plasmicapp/react-web";

export const _useGlobalVariants = createUseGlobalVariants({});
